import * as React from 'react';

export enum IntelSDKStatus {
    Success = 'success',
    Timeout = 'timeout',
    Error = 'error',
}

export type FingerPrintResponseData = {
    visitorId?: string;
    requestId?: string;
    status: IntelSDKStatus;
};

export type IncogniaResponseData = {
    requestToken?: string;
    status: IntelSDKStatus;
};

export type BureauResponseData = {
    sessionId?: string;
    userId?: string;
    status: IntelSDKStatus;
};

export type MangopayResponseData = {
    attemptReference?: string;
    userId?: string;
    status: IntelSDKStatus;
};

export type SardineResponseData = {
    sessionKey?: string;
    status: IntelSDKStatus;
};

export interface ForterResponseData {
    token?: string;
    status: IntelSDKStatus;
}

export type DeviceIntelligenceContext = {
    buildDeviceIntelligenceHeader: (config: DeviceIntelligenceHeaderConfig) => Promise<Record<string, string>>;
    buildDeviceIntelligenceHeaderAsync: () => Promise<void>;
    isDeviceIntelligenceEnabled: () => boolean;
    isDeviceIntelligenceHeaderBuilt: () => boolean;
    getDeviceIntelligenceHeaders: () => Record<string, string>;
};

export const DeviceIntelligenceContext = React.createContext<DeviceIntelligenceContext | null>(null);

export type DeviceIntelligenceHeaderConfig = {
    skipBureau?: boolean;
    skipFingerprint?: boolean;
    skipMangopay?: boolean;
    skipIncognia?: boolean;
    skipSardine?: boolean;
    skipForter?: boolean;
};

export type FingerprintVendorTokens = {
    visitorId: string;
    requestId: string;
};

export type DeviceIntelligenceIds = {
    mangopay: string;
    fingerprint: FingerprintVendorTokens;
    bureau: string;
    incognia: string;
    sardine: string;
    forter: string;
};
